import React from "react";

// Import company logos
import MicronLogoUrl from "/src/assets/org-logos/micron-logo.jpg";
import CATMELogoUrl from "/src/assets/org-logos/catme-logo.png";

interface CompanyIconProps {
  companyName: string;
  size?: number;
  className?: string;
}

// Map company names to their corresponding icon URLs
const companyIconMap: Record<string, string> = {
  "Micron Technology": MicronLogoUrl,
  美光科技: MicronLogoUrl,
  "CATME Smarter Teamwork": CATMELogoUrl,
};

const CompanyIcon: React.FC<CompanyIconProps> = ({
  companyName,
  size = 24,
  className = "",
}) => {
  const iconUrl = companyIconMap[companyName];

  if (!iconUrl) {
    return null; // Return null if no icon is found
  }

  return (
    <img
      src={iconUrl}
      alt={`${companyName} logo`}
      className={className}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        objectFit: "contain",
        borderRadius: companyName.includes("CATME") ? "50%" : "4px",
      }}
    />
  );
};

export default CompanyIcon;
